import { render, staticRenderFns } from "./OmnicaEditTask.vue?vue&type=template&id=5354248a&scoped=true"
import script from "./OmnicaEditTask.vue?vue&type=script&lang=js"
export * from "./OmnicaEditTask.vue?vue&type=script&lang=js"
import style0 from "./OmnicaEditTask.vue?vue&type=style&index=0&id=5354248a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354248a",
  null
  
)

export default component.exports